import React from 'react';
import { tokens } from '../../../theme/tokens';
import type { KpiFlag } from '../../dashboardShared/commandDashboardTokens';
import { KpiStrip } from '../../dashboardShared/components/KpiStrip';
import { DEFAULT_VENDOR_KPIS, VENDOR_KPI_CATALOG } from '../../dashboardShared/kpiCatalog';
import type { KpiCellData } from '../../dashboardShared/types';

export interface Kpi {
  /** Catalog id (`VENDOR_KPI_CATALOG`). */
  id: string;
  label: string;
  value: string;
  sub: string;
  ink?: string;
}

interface KpiRowProps {
  kpis: Kpi[];
  loading?: boolean;
  /** The saved Key numbers list (`config.kpis`); unset shows today's default. */
  order?: string[];
  editing?: boolean;
  onChange?: (ids: string[], removedLabel?: string) => void;
}

/** Maps a KPI's raw ink colour (from `brandHomeTokens`) onto the shared flag vocabulary. */
const inkToFlag = (ink?: string): KpiFlag => {
  if (ink === tokens.signal.problem.ink) return 'red';
  if (ink === tokens.signal.caution.ink) return 'amber';
  return 'none';
};

/** The vendor home's Key numbers: bordered cards in view mode, the shared editable strip in edit mode. */
export const KpiRow: React.FC<KpiRowProps> = ({ kpis, loading, order, editing, onChange }) => {
  const cells: KpiCellData[] = kpis.map((kpi) => ({
    id: kpi.id,
    label: kpi.label,
    value: kpi.value,
    delta: '',
    note: kpi.sub,
    flag: inkToFlag(kpi.ink),
  }));
  return (
    <KpiStrip
      variant="card"
      kpis={cells}
      loading={loading}
      catalog={VENDOR_KPI_CATALOG}
      defaultOrder={DEFAULT_VENDOR_KPIS}
      order={order}
      editing={editing}
      onChange={onChange}
    />
  );
};
